import Store from "../Store";
import { fetchSiteConfig } from "../Store/Slices/DefsSlice";
import { addDays } from "./TimeAndDate";
import { updateDefs } from "./Common";

let expiryType, licenseExpiryObject;

export const addLicenseExpiry = async (siteConfigData, defsCreatedAt) => {
    // console.log("siteConfigData", siteConfigData,"===>",defsCreatedAt);
    let createdAt = defsCreatedAt;
    let productsArr = siteConfigData.products;
    let flg = false;

    for (let i = 0; i < productsArr.length; i++) {
        let pro = productsArr[i];
        if (!pro.licenseExpiry) {
            let exp_date;
            let no_of_days = 0;
            console.log("pro.expiryDatepro.expiryDate", pro.expiryDate);
            if (pro.expiryDate && pro.expiryDate != null && pro.expiryDate != undefined) {
                let dt1 = new Date();
                let dt2 = new Date(pro.expiryDate);
                let diff = Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
                exp_date = pro.expiryDate;
                no_of_days = diff;
            }
            else {
                no_of_days = 365;
                exp_date = addDays(createdAt, no_of_days);
            }
            let arr = [];
            let obj = {
                "po_uuid": "",
                "period": no_of_days,
                "is_active": true,
                "renewal_from": createdAt,
                "valid_till": exp_date,
                "grace_period": 0,
                "end_grace_period": true,
                "extend_grace_period": 0,
                "extend_grace": false,
                "updated_on": createdAt
            };
            arr.push(obj);
            pro.expiryDate = exp_date;
            pro.licenseExpiry = arr;
            flg = true;
        }
    }
    if (flg == true) {
        let newData = {};
        newData.keydata = siteConfigData;
        newData.is_synced = false;
        let params = {
            query: {
                keyid: 'site_config',
                site_uuid: siteConfigData.uuid
            }
        };
        let response = await updateDefs(newData, params);

        if (response.status == 200) {
            Store.dispatch(
                fetchSiteConfig({
                    keyid: "site_config",
                    site_uuid: siteConfigData.uuid
                })
            );
        }
    }
    // Over
};

export const checkProductExpiry = async (siteConfigData1, productId = null) => {
    let siteConfigData = siteConfigData1;
    let currentDate = new Date();
    let productsArr = siteConfigData.products;
    let findProduct, foundProductIndex;
    if (productId == null) {
        findProduct = productsArr[0];
        foundProductIndex = 0;
    }
    else {
        for (let x = 0; x < productsArr.length; x++) {
            if (productsArr[x]['productId'] == productId) {
                foundProductIndex = x;
                findProduct = productsArr[x];
            }
        }
    }
    console.log("findProduct", findProduct);

    let prodLicenseArr = findProduct.licenseExpiry;
    let flg = false;
    let activeLicense, expDate;
    let i;

    for (i = 0; i < prodLicenseArr.length; i++) {
        if (prodLicenseArr[i].is_active == true && prodLicenseArr[i].end_grace_period == false) {
            flg = true;
            break;
        }
    }

    if (flg == true) {
        activeLicense = prodLicenseArr[i];

        let validTillDateObj = new Date(activeLicense.valid_till);
        validTillDateObj.setHours(0, 0, 0, 0);

        if (validTillDateObj.getTime() < currentDate.getTime()) {
            expiryType = 'validity_expire';
        }
        else {
            expiryType = 'grace_period';
        }

        expDate = addDays(activeLicense.renewal_from, activeLicense.grace_period);
    }
    else {
        expiryType = 'validity_expire';
        activeLicense = prodLicenseArr[i - 1];
        expDate = activeLicense.valid_till;

        let validTillDateObj = new Date(activeLicense.valid_till);
        validTillDateObj.setHours(0, 0, 0, 0);

        if (validTillDateObj.getTime() < currentDate.getTime()) {
            if (activeLicense.extend_grace == true) {
                expDate = addDays(expDate, activeLicense.extend_grace_period);
            }
        }
    }

    licenseExpiryObject = activeLicense;

    let expiryDate = new Date(findProduct.expiryDate);
    let activeLicenseExpiryDate = new Date(licenseExpiryObject.valid_till);
    if (expiryDate.getTime() != activeLicenseExpiryDate.getTime()) {
        findProduct.expiryDate = licenseExpiryObject.valid_till;
        siteConfigData.products[foundProductIndex] = findProduct;
        let newData = {
            'keydata': siteConfigData,
            'is_synced': false
        };
        let params = {
            query: {
                keyid: 'site_config',
                site_uuid: siteConfigData.uuid
            }
        };
        let response = await updateDefs(newData, params);
        if (response.status == 200) {
            Store.dispatch(
                fetchSiteConfig({
                    keyid: "site_config",
                    site_uuid: siteConfigData.uuid
                })
            );
        }

    }
    expDate = new Date(expDate);
    console.log("expDateexpDate==============", expDate);
    let diff = Math.floor((Date.UTC(expDate.getFullYear(), expDate.getMonth(), expDate.getDate()) - Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())) / (1000 * 60 * 60 * 24));
    console.log("diff==========", diff);
    return diff;
};

export const checkExpiryProductWithFlag = async (siteConfigData, productId = null) => {
    let res = await checkProductExpiry(siteConfigData, productId);
    let obj = {
        'difference': res,
        'expiryType': expiryType,
        'activeLicenseObj': licenseExpiryObject
    };
    return obj;
};



